export default function modifyFieldConfig(field, cb) {
  if (Array.isArray(field)) {
    const modified = cb(field[1], field[0], field.slice(2))
    return [
      field[0],
      ...(
        Array.isArray(modified)
        ? modified
        : [modified]
      ),
    ];
  }
  return cb(field);
}
